// import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import html2canvas from 'html2canvas';
import * as JSpdf from 'jspdf';
import DatePicker from 'material-ui/DatePicker';
import MenuItem from 'material-ui/MenuItem';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import { connect } from "react-redux";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import KeyboardedInput from 'react-touch-screen-keyboard';
import 'react-touch-screen-keyboard/lib/Keyboard.css';
import * as actions from '../../actions/actions.jsx';
import '../../stylesheet/cardactivity.css';
import '../../stylesheet/cardsummary.css';
import '../../stylesheet/tabdesign.css';
import '../../stylesheet/virtualkeyboard.css';
import Loader from '../loader/loader.jsx';
// import AuthNavbar from '../navigation/authnavigation.jsx'
import AdminNavbar from '../navigation/adminnavigation.jsx';

const escapeRegexCharacters = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');


const getSuggestions = (value, countryState) => {
    const escapedValue = escapeRegexCharacters(value.trim());

    if (escapedValue === '') {
        return [];
    }

    const regex = new RegExp('^' + escapedValue, 'i');

    const suggestions = countryState.filter(country => regex.test(country.name));

    if (suggestions.length === 0) {
        return [
            { name: "No Country Found" }
        ];
    }

    return suggestions;
}
const styles = {
    customWidth: {
        width: 150,
    },
    customWidth1: {
        width: "100%",
        fontSize: "14px",
        cursor: "pointer"

    },
    customWidth2: {
        width: "100%",
        fontSize: "12px",
        fontWeight: "600"

    },
    root: {
        // backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    customWidth3: {
        width: "100%",
        fontSize: "10px !important",
        fontWeight: "600"

    },


    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    },
    underlineStyle1: {
        borderTop: "none rgb(224, 224, 224)",
        borderLeft: "none rgb(224, 224, 224)",
        borderRight: "none rgb(224, 224, 224)",
        borderBottom: "1px solid #333",
        position: "relative",
        width: "98%"

    },
    buttonStyle: {
        background: "rgba(41, 40, 40, 0.87)",
    },
    floatingLabelStyle: {
        color: "#333",
        fontSize: "14px",
        fontWeight: 600

    },

    radioButton: {
        marginBottom: 5,
        marginTop: 5,
        width: "25%",
        display: "inline",

    },
    radioButton1: {
        marginBottom: 5,
        marginTop: 5,
        width: "25%",
        display: "inline",
        marginLeft: "1%",
    },
    floatingLabelFocusStyle: {
        color: "#333"
    },
    groupstyle: {
        display: "flex",
        width: "100%"
    },
    tabRoot: {
        textTransform: 'initial',
    },
}

const mapStateToProps = state =>
({
    cardDetailState: state.getCardDetailsReducer.cardDetailState,
    countryState: state.countryReducer.countryState,
    cardactivity: state.getCardActivityReducer.cardactivity
})
const mapDispatchToProps = dispatch =>
({
    getCardDetails(cardRefNo) {
        dispatch(
            actions.getCardDetailAction(cardRefNo)
        )
    },
    fetchCountryState() {
        dispatch(
            actions.countryAction()
        )
    },
    fetchCardActivity(cardRefNo, startDate, endDate, statementPeriod, transactionType) {
        dispatch(
            actions.getCardActivity(cardRefNo, startDate, endDate, statementPeriod, transactionType)
        )
    },
})


class CardDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            address: '',
            address2: '',
            cardNumber: '',
            city: '',
            country: '',
            countryCode: '',
            dateofbirth: '',
            emailId: '',
            firstName: '',
            gender: '',
            QuickLoad: false,
            homePhoneNumber: '',
            lastName: '',
            confirmPIN: "",
            newPIN: "",
            mobileNumber: '',
            pincode: '',
            portalCardStatus: '',
            secretAnswer: '',
            secretQuestion: '',
            state: '',
            userName: '',
            cardStatus: '',
            disabled: true,
            disabled1: true,
            correctEmail: true,
            activityFromDate: "",
            activityToDate: "",
            details: true,
            coreectfirstName: true,
            suggestions: [],
            cardactivity: {},
            value3: '',
            valueTab: 0,
            value: '',
            loader: true,
            value4: 'all',
            todatestate: true,
            transactionType: "P",
            statementPeriod: 7,
            selectedOption: "tab1",
            correctpin: true,
            cardReferenceId: localStorage.getItem('cardRefNumber'),
            customMapping: [

            ],

        }

        this.multipleSelect = this.multipleSelect.bind(this)
        this.handleValueChange = this.handleValueChange.bind(this);
    }

    // static getDerivedStateFromProps(nextProps, prevState){

    //     if(nextProps.cardDetailState!==prevState.cardDetailState){
    //       return { cardDetailState: nextProps.cardDetailState};
    //    }
    //     else return null;
    //  }

    //  componentDidUpdate(prevProps, prevState) {
    //     if(prevProps.cardDetailState!==this.state.cardDetailState){
    //       //Perform some operation here
    //       this.setState({cardDetailState: cardDetailState});
    //     }
    //   }
    componentDidMount() {
        // document.getElementById('newpin').onkeypress = function () { return false; }
        // document.getElementById('confpin').onkeypress = function () { return false; }
        this.props.getCardDetails(localStorage.getItem('cardRefNumber'))
        this.props.fetchCountryState()

        if (this.props.cardDetailState.status === 401) {

            localStorage.clear();
            this.props.history.push('/SessionOut')
        }
    }
    onChange1 = (event, { newValue }) => {
        // let addval = newValue.trim()
        if (newValue.name === "") {
            this.setState({
                disabledcontact: false
            })
        }
        else {
            this.setState({
                value3: newValue,
                disabledcontact: true
            })

        }
    };
    handleValueChange(val) {
        if (val.length <= 4) {
            this.setState({ confirmPIN: val }
                , () => {

                    if (this.state.newPIN !== "" && this.state.confirmPIN !== "") {
                        this.setState({
                            disabled: false

                        })
                    }
                    else {
                        this.setState({
                            disabled: true
                        })
                    }

                });
        }
    }
    removepin = () => {
        this.setState({
            correctpin: true
        })
    }
    handleValueChangenew(val) {

        if (val.length <= 4) {
            this.setState({
                newPIN: val,
                correctpin: true,
            }
                , () => {

                    if (this.state.newPIN !== "" && this.state.confirmPIN !== "") {
                        this.setState({
                            disabled: false

                        })
                    }
                    else {
                        this.setState({
                            disabled: true
                        })
                    }

                });
        }
    }
    handleTabChange = (event, valueTab) => {
        this.setState({
            valueTab,

        }, () => {

            {
                this.state.valueTab === 2

                this.props.fetchCardActivity(this.state.cardRefNo, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod, this.state.transactionType)
            } () => {
                this.setState({
                    loader: false
                })
            }
        });

    };
    handleChange = (event) => {
        this.setState({
            value4: event.target.value
        })
    };
    handleChange7(e) {
        this.setState({
            selectedOption: e.target.value,
            transactionType: "P",
            loader: false
        }, () => {
            this.props.fetchCardActivity(this.state.cardDetailsId, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod, this.state.transactionType)
        }, () => {
            this.setState({
                loader: false
            })
        })
    }

    handleChange8(e) {
        this.setState({
            selectedOption: e.target.value,
            transactionType: "A",
            loader: false
        }, () => {
            this.props.fetchCardActivity(this.state.cardDetailsId, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod, this.state.transactionType)
        }, () => {
            this.setState({
                loader: false
            })
        })
    }


    handleChangeIndex = index => {
        this.setState({ value: index });
    };
    getSuggestionValue = suggestion => {

        // if(suggestion.name="No Country Found"){
        //     this.setState({
        //         correctcountry:false
        //     })
        // }
        this.setState({
            country: suggestion.name,
            countryCode: suggestion.alpha3Code
        }, () => {

        })
        return suggestion.name;
    };


    renderSuggestion = suggestion => {
        return suggestion.name || suggestion.name;
    };

    onSuggestionsFetchRequested = ({ value }) => {

        this.setState({
            suggestions: getSuggestions(value, this.props.countryState)
        }, () => {

        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: this.state.country
        });
    };
    onSuggestionSelected = (event) => {

    };

    componentWillReceiveProps(nextProps) {


        this.setState({
            loader: true
        })
        if (nextProps.cardDetailState.status === 200) {
            this.setState({
                address: nextProps.cardDetailState.body.address,
                address2: nextProps.cardDetailState.body.address2,
                cardNumber: nextProps.cardDetailState.body.cardNumber,
                // cardStatus: nextProps.cardDetailState.body.cardStatus,
                city: nextProps.cardDetailState.body.city,
                value3: nextProps.cardDetailState.body.country,
                countryCode: nextProps.cardDetailState.body.countryCode,
                dateofbirth: nextProps.cardDetailState.body.dateofbirth,
                // emailId: nextProps.cardDetailState.body.emailId,
                firstName: nextProps.cardDetailState.body.firstName,
                gender: nextProps.cardDetailState.body.gender,
                homePhoneNumber: nextProps.cardDetailState.body.homePhoneNumber,
                lastName: nextProps.cardDetailState.body.lastName,
                mobileNumber: nextProps.cardDetailState.body.mobileNumber,
                pincode: nextProps.cardDetailState.body.pincode,
                portalCardStatus: nextProps.cardDetailState.body.portalCardStatus,
                secretAnswer: nextProps.cardDetailState.body.secretAnswer,
                secretQuestion: nextProps.cardDetailState.body.secretQuestion,
                state: nextProps.cardDetailState.body.state,
                userName: nextProps.cardDetailState.body.userName,
            })
        }
    }

    handleStatus = (event, index, status) => {
        this.setState({
            cardStatus: status,
            disabled: false
        })
    }
    handlecardactivity = () => {
        if (Date.parse(this.state.activityToDate) <= Date.parse(this.state.activityFromDate)) {
            this.setState({
                todatestate: false,
            })
        }
        else {

            this.setState({
                activityFromDate: this.state.activityFromDate,
                activityToDate: this.state.activityToDate,
                applicationId: "gmcabs",
                cardDetailsId: this.state.cardDetailsId,
                statementPeriod: 0

            }, () => {
                this.setState({
                    loader: true
                })
                this.props.fetchCardActivity(this.state.cardDetailsId, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod, this.state.transactionType)

            }, () => {
                this.setState({
                    loader: false
                })
            })
        }
    }


    handleSelectmonth = (event, index, value) => {

        this.setState({
            statementPeriod: value
        }, () => {

            if (this.state.statementPeriod === 0) {
                const state = {
                    activityFromDate: this.state.activityFromDate,
                    activityToDate: this.state.activityToDate,
                    cardDetailsId: this.state.cardDetailsId,
                    statementPeriod: this.state.statementPeriod

                }
                this.setState({
                    loader: false,

                })
                let token = "Token " + localStorage.getItem('token')
                let baseUrl = localStorage.getItem('serviceUrl')
                fetch(baseUrl + "/rest/card/getCardActivity", {
                    method: "POST",
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': token
                    },
                    body: JSON.stringify(state)

                })
                    .then(response => {
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                        this.setState({
                            loader: false
                        })
                    })
            } else {

                this.setState({
                    loader: false
                })
                this.props.fetchCardActivity(this.state.cardDetailsId, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod, this.state.transactionType)

            }

        });
    }
    handleClick = () => {
        document.getElementById('myModal').style.display = 'block'
    }
    handleClose = () => {
        document.getElementById("myModal").style.display = "none"
    }

    handleUpdate = () => {
        let _this = this
        const state = {
            cardReferenceId: localStorage.getItem('cardRefNumber'),
            cardStatus: this.state.cardStatus
        }
        let token = "Token " + localStorage.getItem('token')
        let baseUrl = localStorage.getItem('serviceUrl')
        fetch(baseUrl + "/rest/card/updateCardStatusByRefId", {
            method: "POST",
            headers: {
                'content-type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(state)

        })
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        newestOnTop: true,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    this.props.getCardDetails(localStorage.getItem('cardRefNumber'))
                    _this.handleClose()
                    // this.setState({
                    //     loader: false
                    // })
                }
                else if (response.status === 401) {
                    localStorage.clear();
                    this.props.history.push('/SessionOut')
                }
                else {
                    // this.setState({
                    //     loader: true
                    // })

                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        newestOnTop: true,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });



                }
            })
    }
    handleUpdatePIN = () => {
        let _this = this
        const { newPIN } = this.state
        const state = {
            cardReferenceId: localStorage.getItem('cardRefNumber'),
            applicationId: localStorage.getItem('applicationId'),
            newPIN: newPIN,
        }
        let token = "Token " + localStorage.getItem('token')
        let baseUrl = localStorage.getItem('serviceUrl')
        fetch(baseUrl + "/rest/card/resetPIN", {
            method: "POST",
            headers: {
                'content-type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(state)

        })
            .then(response => {
                if (response.status === 200 || response.status === 201 || response.status === 204) {
                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        newestOnTop: true,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    setTimeout(function () {
                        //_this.props.history.push('/cardsearch')
                        _this.handleClose2()
                    }, 3000)

                    this.setState({
                        loader: false
                    })
                }
                else if (response.status === 401) {
                    localStorage.clear();
                    this.props.history.push('/SessionOut')
                }
                else {
                    // this.setState({
                    //     loader: true
                    // })

                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        newestOnTop: true,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                }
            })
    }
    handleEmailId = (e, value) => {
        if (e.target.name === 'emailid' && e.target.value.length !== 0) {
            if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,40}))$/.test(e.target.value)) {
                this.setState({
                    emailId: value,
                    disabled1: false,
                    correctEmail: true,
                })
            }

            else {
                this.setState({
                    disabled1: true,
                    correctEmail: false,
                })
            }
        }
    }
    handleEmailSubmit = () => {
        document.getElementById('myModal1').style.display = 'block'
    }
    handlePINSubmit = () => {
        document.getElementById('myModal2').style.display = 'block'
    }

    handleUpdateEmail = () => {
        let _this = this
        const state = {
            emailId: this.state.emailId,
            memberId: this.props.cardDetailState.body.memberId

        }
        let token = "Token " + localStorage.getItem('token')
        let baseUrl = localStorage.getItem('serviceUrl')
        fetch(baseUrl + "/rest/profile/updateEmailAddress", {
            method: "POST",
            headers: {
                'content-type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(state)

        })
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: true,
                        newestOnTop: true
                    });
                    setTimeout(function () {
                        _this.setState({ details: true })
                        _this.handleClose1()
                        _this.props.getCardDetails(localStorage.getItem('cardRefNumber'))
                    }, 3000)

                    // this.setState({
                    //     loader: false
                    // })
                }
                else if (response.status === 401) {
                    localStorage.clear();
                    this.props.history.push('/SessionOut')
                }
                else {
                    // this.setState({
                    //     loader: true
                    // })

                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: true,
                        newestOnTop: true
                    });



                }
            })
    }
    handleClose1 = () => {
        document.getElementById("myModal1").style.display = "none"
    }
    handleClose2 = () => {
        document.getElementById("myModal2").style.display = "none"
    }
    handleEdit = () => {
        this.setState({
            details: false
        })
    }

    handleCancel = () => {
        this.setState({
            details: true
        })
    }
    formatDate = (date) => {
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        return `${(day < 10) ? ('0' + day) : day}/${(month < 10) ? ('0' + month) : month}/${year}`
    }


    handleDOB = (event, dob) => {

        var dob1 = new Date(dob);
        var ISostring = dob1.toISOString();
        this.setState({
            dateofbirth: ISostring,
            dobDate: this.converDate(dob)
        })

    }
    handleEditChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }


    multipleSelect(e) {
        e.preventDefault()
        let body = this.props.countryState
        let item = body.find(item => item.name === e.target.value)
        this.props.multiSelect({ name: [e.target.name], value: item })
    }
    handleDownload() {


        // setTimeout(() => {
        if (this.props.cardactivity.body.transactions.length !== 0) {
            this.setState({
                quickLoad: true
            })
            const input = document.getElementById('carddivPrint');
            html2canvas(input)
                .then((canvas) => {
                    const img = canvas.toDataURL('image/png');
                    //const pdf = new jsPDF('p', 'mm');
                    //let img = pdf.addImage(imgData, 'JPEG', 0, 0);
                    var imgWidth = 210;
                    var pageHeight = 295;
                    var imgHeight = canvas.height * imgWidth / canvas.width;
                    var heightLeft = imgHeight;

                    const pdf = new JSpdf('p', 'mm')
                    var position = 0;

                    pdf.addImage(img, 'PNG', 0, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;

                    while (heightLeft >= 0) {
                        position = heightLeft - imgHeight;
                        pdf.addPage();
                        pdf.addImage(img, 'PNG', 0, position, imgWidth, imgHeight);
                        heightLeft -= pageHeight;
                    }
                    // pdf.output('dataurlnewwindow');
                    pdf.save("download.pdf");
                });
            setTimeout(() => {
                this.setState({ quickLoad: false })
            }, 2000)
        }
        // }, 10)
        else {
            toast.error('No content available for download.', {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
            });
        }

    }

    handleFromDate = (e, date) => {
        this.setState({
            activityFromDate: this.converDate(date)

            // dob: this.converDate(date)
        }, () => {
            if (this.state.activityFromDate.length !== 0 && this.state.activityToDate.length !== 0) {
                this.setState({
                    disabled: false

                })
            }
            else {
                this.setState({
                    disabled: true
                })
            }

        })
    }
    handleToDate = (e, date) => {
        this.setState({
            activityToDate: this.converDate(date)
            // dob: this.converDate(date)
        }, () => {

            if (this.state.activityFromDate.length !== 0 && this.state.activityToDate.length !== 0) {
                this.setState({
                    disabled: false

                })
            }
            else {
                this.setState({
                    disabled: true
                })
            }

        })
    }
    comparedate = () => {
        const { activityFromDate, activityToDate } = this.state
        if (Date.parse(activityToDate) <= Date.parse(activityFromDate)) {

        }
    }
    converDate(date) {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [
            (mm > 9 ? '' : '0') + mm,
            (dd > 9 ? '' : '0') + dd,
            date.getFullYear()
        ].join('/');
    }
    formatDate = (date) => {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();
        return [

            (dd > 9 ? '' : '0') + dd,
            (mm > 9 ? '' : '0') + mm,
            date.getFullYear()
        ].join('/');
    }

    updateCardHolderInfo = () => {
        const { cardDetailState } = this.props
        let state = {
            cardNumber: cardDetailState.body.cardNumber,
            cardReferenceId: cardDetailState.body.cardReferenceId,
            memberId: cardDetailState.body.memberId,
            firstName: this.state.firstName || cardDetailState.body.firstName,
            lastName: this.state.lastName || cardDetailState.body.lastName,
            dateofbirth: this.state.dateofbirth || cardDetailState.body.dateofbirth,
            mobileNumber: this.state.mobileNumber || cardDetailState.body.mobileNumber,
            emailId: this.state.emailId || cardDetailState.body.emailId,
            address: this.state.address || cardDetailState.body.address,
            address2: this.state.address2 || cardDetailState.body.address2,
            city: this.state.city || cardDetailState.body.city,
            pincode: this.state.pincode || cardDetailState.body.pincode,
            state: this.state.state || cardDetailState.body.state,
            country: this.state.country || cardDetailState.body.country,
            countryCode: this.state.countryCode || cardDetailState.body.countryCode,
            dobDate: this.state.dobDate || cardDetailState.body.dobDate,

        }
        let token = "Token " + localStorage.getItem('token')
        let baseUrl = localStorage.getItem('serviceUrl')
        fetch(baseUrl + "/rest/profile/updateProfile", {
            method: "POST",
            headers: {
                'content-type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(state)

        })
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: true,
                        newestOnTop: true
                    });
                    this.props.getCardDetails(localStorage.getItem('cardRefNumber'))
                    this.setState({
                        details: true
                    })
                }
                else if (response.status === 401) {
                    localStorage.clear();
                    this.props.history.push('/SessionOut')
                }
                else {
                    // this.setState({
                    //     loader: true
                    // })

                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: true,
                        newestOnTop: true
                    });
                }
            })
    }


    render() {
        const { cardDetailState, cardactivity } = this.props

        const { details, correctpin, value3, value4, suggestions } = this.state
        const inputProps = {
            placeholder: "Country",
            value: value3,
            maxLength: 50,
            onChange: this.onChange1

        };
        return (
            <div>
                <div className="col-sm-12">
                    <AdminNavbar />
                </div>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <div className="col-sm-12" style={{ marginTop: "100px" }}>
                    <span style={{ fontSize: "25px", fontWeight: "400" }}>
                        Card Search Results
                    </span>
                </div>
                {(cardDetailState.status === 200) ?
                    <div className="col-sm-11" style={{ marginLeft: "20px", marginTop: "20px" }}>
                        <div className="col-sm-12" style={{ padding: "0px" }}>
                            <div className="row">
                                <div className="col-sm-5">

                                    <div className="col-sm-12" style={{ padding: "0px" }}>
                                        <div className="col-sm-12" style={{ marginBottom: "8%" }}>
                                            <table className="table table-active table-striped" style={{ marginLeft: "20px", marginTop: "15px" }}>
                                                <thead className="thead-dark">
                                                    <tr style={{ fontSize: "11px" }}>
                                                        <th scope="col" colspan="2" style={{ padding: "10px", textAlign: "center", fontSize: "15px" }}>Cardholder Information <i className="fa fa-edit" onClick={this.handleEdit.bind(this)} style={{ marginRight: "10px", fontSize: "15px", fontWeight: "bold", cursor: "pointer", float: "right", marginTop: "4px" }} title="Edit Cardholder Information">  </i> </th>
                                                        {/* <th style={{ padding: "5px 0px 10px 20px", }} > </th> */}
                                                    </tr>

                                                </thead>

                                                <tbody id="myTable" style={{ fontSize: "15px" }}>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>User ID:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.userName}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Card Number:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.cardNumber}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Card Ref. Number:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.cardReferenceId}</td>

                                                    </tr>
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>First Name:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.firstName}</td>

                                                        </tr>
                                                        :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>First Name:</td>
                                                            <TextField
                                                                id="standard-bare"
                                                                className="input-width required"
                                                                name="firstName"
                                                                defaultValue={cardDetailState.body.firstName}
                                                                onChange={this.handleEditChange.bind(this)}
                                                                margin="normal"
                                                                style={styles.customWidth2}
                                                                underlineStyle={styles.underlineStyle1}
                                                            />
                                                        </tr>}

                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Last Name:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}>{cardDetailState.body.lastName}</td>

                                                        </tr>
                                                        :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Last Name:</td>
                                                            <TextField
                                                                id="standard-bare"
                                                                className="input-width required"
                                                                name="lastName"
                                                                defaultValue={cardDetailState.body.lastName}
                                                                onChange={this.handleEditChange.bind(this)}
                                                                margin="normal"
                                                                style={styles.customWidth2}
                                                                underlineStyle={styles.underlineStyle1}
                                                            />
                                                        </tr>}

                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Date of Birth:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.dateofbirth}</td>

                                                        </tr> :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Date of Birth:</td>

                                                            <DatePicker
                                                                // floatingLabelText="Date Of Birth"
                                                                textFieldStyle={{ width: "100%", fontSize: "12px", fontWeight: "600" }}
                                                                defaultDate={new Date(cardDetailState.body.dobDate)}
                                                                onChange={this.handleDOB.bind(this)}
                                                                formatDate={this.formatDate}
                                                                maxDate={new Date()}
                                                                underlineStyle={styles.underlineStyle1}
                                                            // style={styles.customWidth3}
                                                            />
                                                        </tr>}
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Address 1:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.address}</td>

                                                        </tr>
                                                        :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Address 1:</td>
                                                            <TextField
                                                                id="standard-bare"
                                                                className="input-width required"
                                                                name="address"
                                                                defaultValue={cardDetailState.body.address}
                                                                margin="normal"
                                                                onChange={this.handleEditChange.bind(this)}
                                                                underlineStyle={styles.underlineStyle1}
                                                                style={styles.customWidth2}
                                                            />
                                                        </tr>
                                                    }
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Address 2:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}>{cardDetailState.body.address2}</td>

                                                        </tr>
                                                        :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Address 2:</td>
                                                            <TextField
                                                                id="standard-bare"
                                                                className="input-width required"
                                                                defaultValue={cardDetailState.body.address2}
                                                                margin="normal"
                                                                name="address2"
                                                                onChange={this.handleEditChange.bind(this)}
                                                                underlineStyle={styles.underlineStyle1}
                                                                style={styles.customWidth2}
                                                            />
                                                        </tr>
                                                    }
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>City:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.city}</td>

                                                        </tr> :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>City:</td>
                                                            <TextField
                                                                id="standard-bare"
                                                                className="input-width required"
                                                                defaultValue={cardDetailState.body.city}
                                                                margin="normal"
                                                                name="city"
                                                                onChange={this.handleEditChange.bind(this)}
                                                                underlineStyle={styles.underlineStyle1}
                                                                style={styles.customWidth2}
                                                            />
                                                        </tr>
                                                    }
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>State/Province:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.state}</td>

                                                        </tr> :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>State/Province:</td>
                                                            <TextField
                                                                id="standard-bare"
                                                                className="input-width required"
                                                                defaultValue={cardDetailState.body.state}
                                                                margin="normal"
                                                                name="state"
                                                                onChange={this.handleEditChange.bind(this)}
                                                                underlineStyle={styles.underlineStyle1}
                                                                style={styles.customWidth2}
                                                            />
                                                        </tr>
                                                    }
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Zip/Postal Code:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.pincode}</td>

                                                        </tr>
                                                        :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Zip/Postal Code:</td>
                                                            <TextField

                                                                className="input-width required"
                                                                defaultValue={cardDetailState.body.pincode}
                                                                margin="normal"
                                                                onChange={this.handleEditChange.bind(this)}
                                                                underlineStyle={styles.underlineStyle1}
                                                                style={styles.customWidth2}
                                                                id="standard-number"
                                                                type="text"
                                                                name="pincode"
                                                            />
                                                        </tr>
                                                    }
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Country:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.country}</td>

                                                        </tr> :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Country:</td>
                                                            {/* <MultipleSelect
                                                        image
                                                        name="country"
                                                        items={this.state.countryState}
                                                        kiey="alpha3Code"
                                                        value="alpha3Code"
                                                        default={ this.state.countryName }                                                     
                                                        description="name"
                                                        flag="flag"
                                                        searchKey="name"
                                                        selectValue={this.handlemcountryempty.bind(this)} 
                                                
                                                  /> */}
                                                            <Autosuggest

                                                                suggestions={suggestions}
                                                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                                                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                                                getSuggestionValue={this.getSuggestionValue}
                                                                renderSuggestion={this.renderSuggestion}
                                                                onSuggestionSelected={this.onSuggestionSelected}
                                                                inputProps={inputProps}
                                                            // errorText={correctcountry ? null : "Not a valid name"}
                                                            />
                                                        </tr>
                                                    }

                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Secret Question:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.secretQuestion}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Answer:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.secretAnswer}</td>

                                                    </tr>
                                                    {/* <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Home Phone Number:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.homePhoneNumber}</td>

                                                    </tr> */}
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Mobile Number:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.mobileNumber}</td>

                                                        </tr> :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Mobile Number:</td>
                                                            <TextField

                                                                className="input-width required"
                                                                defaultValue={cardDetailState.body.mobileNumber}
                                                                margin="normal"
                                                                onChange={this.handleEditChange.bind(this)}
                                                                underlineStyle={styles.underlineStyle1}
                                                                style={styles.customWidth2}
                                                                id="standard-number"
                                                                type="text"
                                                                name="mobileNumber"
                                                            />
                                                        </tr>
                                                    }
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>E-mail:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.emailId}</td>

                                                        </tr> :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>E-mail:</td>
                                                            <TextField
                                                                id="standard-bare"
                                                                className="input-width required"
                                                                defaultValue={cardDetailState.body.emailId}
                                                                margin="normal"
                                                                onChange={this.handleEditChange.bind(this)}
                                                                underlineStyle={styles.underlineStyle1}
                                                                style={styles.customWidth2}
                                                                name="emailId"
                                                            />
                                                        </tr>
                                                    }



                                                </tbody>


                                            </table>
                                        </div>
                                        {details ?
                                            null :
                                            <div className="col-sm-12">
                                                <div className="row">
                                                    <div className="col-sm-3 offset-3" style={{ marginTop: "7px", marginBottom: "5%", padding: "0px 0px 15px 35px" }}>
                                                        <RaisedButton
                                                            label="Cancel"
                                                            backgroundColor="#333"
                                                            labelColor="#fff"
                                                            onClick={this.handleCancel.bind(this)}
                                                        />
                                                    </div>
                                                    <div className="col-sm-3 " style={{ marginTop: "7px", marginBottom: "10px", padding: "0px 0px 15px 35px" }}>
                                                        <RaisedButton
                                                            label="Update"
                                                            backgroundColor="#333"
                                                            labelColor="#fff"
                                                            onClick={this.updateCardHolderInfo.bind(this)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>

                                </div>
                                <div className="col-sm-7" style={{ padding: "15px 10px 0px 25px", }}>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <AppBar position="static" style={{ background: "rgb(33, 37, 41)" }}>
                                                <Tabs
                                                    value={this.state.valueTab}
                                                    onChange={this.handleTabChange}
                                                    indicatorColor="primary"
                                                    textColor="inherit"
                                                    variant="fullWidth"
                                                    centered>
                                                    <Tab label="Update Card Status" />
                                                    {/* <Tab label="Update Email Id" /> */}
                                                    <Tab label="Transaction History" />
                                                    <Tab label="Change PIN" />
                                                </Tabs>
                                            </AppBar>

                                            {this.state.valueTab === 0 &&
                                                <div className="col-sm-12" style={{ padding: "0px", boxShadow: "0px 1px 3px 2px rgba(0,0,0,0.2)", }}>
                                                    {/* <div className="col-sm-12" style={{ background: "#eeeeee", padding: "0px", minHeight: "43px", textAlign: "center", backgroundColor: "#212529", color: "#fff" }}>
                                           <div style={{ padding: "10px", fontSize: "15px", fontWeight: "600" }}>Update Card Status</div>
                                       </div> */}
                                                    <div className="col-sm-12" style={{ marginTop: "10px" }}>
                                                        <div className="row">
                                                            <div className="col-sm-7" style={{ textAlign: "right" }}>
                                                                <span>
                                                                    Current Card Status:
                                               </span>
                                                            </div>
                                                            {(cardDetailState.status === 200) ?
                                                                <div className="col-sm-4" style={{ fontWeight: "600", fontSize: "15px" }}>
                                                                    <span>
                                                                        {cardDetailState.body.portalCardStatus}
                                                                    </span>
                                                                </div>
                                                                :
                                                                <div></div>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-12" style={{ marginTop: "5px" }}>
                                                        <div className="row">
                                                            <div className="col-sm-7" style={{ textAlign: "right" }}>
                                                                <span>
                                                                    Card Status at Processor:
                                               </span>
                                                            </div>
                                                            {(cardDetailState.status === 200) ?
                                                                <div className="col-sm-4" style={{ fontWeight: "600", fontSize: "15px" }}>
                                                                    <span>
                                                                        {cardDetailState.body.cardStatus}
                                                                    </span>
                                                                </div>
                                                                :
                                                                <div></div>
                                                            }
                                                        </div>
                                                    </div>
                                                    {cardDetailState.body && cardDetailState.body.cardStatus === "Open" ?
                                                        <div className="offset-2 col-sm-7">
                                                            <SelectField
                                                                floatingLabelText="Update Card Status"
                                                                name="cardStatus"
                                                                onChange={this.handleStatus.bind(this)}
                                                                floatingLabelStyle={styles.floatingLabelStyle}
                                                                style={styles.customWidth1}
                                                                value={this.state.cardStatus}
                                                            >
                                                                <MenuItem value="B" primaryText="Open" />
                                                                <MenuItem value="I" primaryText="Block" />
                                                                <MenuItem value="F" primaryText="Closed" />
                                                            </SelectField>
                                                        </div>

                                                        :
                                                        <div></div>

                                                    }
                                                    {cardDetailState.body && cardDetailState.body.cardStatus === "Inactive/Blocked Card" ?

                                                        <div className="offset-2 col-sm-7">
                                                            <SelectField
                                                                floatingLabelText="Update Card Status"
                                                                name="cardStatus"
                                                                onChange={this.handleStatus.bind(this)}
                                                                floatingLabelStyle={styles.floatingLabelStyle}
                                                                style={styles.customWidth1}
                                                                value={this.state.cardStatus}
                                                            >
                                                                <MenuItem value="I" primaryText="Inactive/Blocked" />
                                                                <MenuItem value="B" primaryText="Un-Block" />
                                                                <MenuItem value="F" primaryText="Closed" />

                                                            </SelectField>
                                                        </div>
                                                        :
                                                        <div></div>
                                                    }
                                                    {cardDetailState.body && cardDetailState.body.cardStatus === "Closed Card" ?
                                                        <div className="offset-2 col-sm-7">
                                                            <SelectField
                                                                floatingLabelText="Update Card Status"
                                                                name="cardStatus"
                                                                onChange={this.handleStatus.bind(this)}
                                                                floatingLabelStyle={styles.floatingLabelStyle}
                                                                style={styles.customWidth1}
                                                                value={this.state.cardStatus}
                                                            >

                                                                <MenuItem value="F" primaryText="Closed" />

                                                            </SelectField>
                                                        </div>
                                                        :
                                                        <div></div>
                                                    }
                                                    {cardDetailState.body && cardDetailState.body.cardStatus === "Blocked Card due to fraud" ?
                                                        <div className="offset-2 col-sm-7">
                                                            <SelectField
                                                                floatingLabelText="Update Card Status"
                                                                name="cardStatus"
                                                                onChange={this.handleStatus.bind(this)}
                                                                floatingLabelStyle={styles.floatingLabelStyle}
                                                                style={styles.customWidth1}
                                                                value={this.state.cardStatus}
                                                            >
                                                                <MenuItem value="B" primaryText="Open" />
                                                                <MenuItem value="F" primaryText="Closed" />

                                                            </SelectField>
                                                        </div>
                                                        :
                                                        <div></div>
                                                    }


                                                    <div className="col-sm-8 offset-4" style={{ marginTop: "7px", marginBottom: "10px", padding: "0px 0px 15px 35px" }}>
                                                        <RaisedButton
                                                            label="Submit"
                                                            backgroundColor="#333"
                                                            labelColor="#fff"
                                                            disabled={this.state.disabled}
                                                            onClick={this.handleClick.bind(this)}
                                                        />
                                                    </div>
                                                </div>
                                            }

                                            {this.state.valueTab === 1 &&
                                                <div className="col-sm-12 nopadding">
                                                    <div className="card">
                                                        <div className="card-header">
                                                            <div className="row">
                                                                <div className="col-sm-3 nopadding" style={{ marginTop: "15px", marginLeft: "15px" }}>Statement Period</div>
                                                                <div className="col-sm-8">
                                                                    <div className="row">
                                                                        <div className="col-sm-6 nopadding">
                                                                            <SelectField

                                                                                onChange={this.handleSelectmonth}
                                                                                className="input-width"
                                                                                name="statementPeriod"
                                                                                value={this.state.statementPeriod}
                                                                            >
                                                                                {/* <MenuItem value={1} primaryText="Select transfer status" /> */}
                                                                                <MenuItem value={0} primaryText="Select Duration" />
                                                                                <MenuItem value={1} primaryText="Today" />
                                                                                <MenuItem value={2} primaryText="Yesterday" />
                                                                                <MenuItem value={3} primaryText="Last Week  " />
                                                                                <MenuItem value={4} primaryText="This Month" />
                                                                                <MenuItem value={5} primaryText="This Year" />
                                                                                <MenuItem value={6} primaryText="Last Month" />
                                                                                <MenuItem value={7} primaryText="Last 3 Months" />
                                                                                <MenuItem value={8} primaryText="Last 6 Months" />
                                                                                <MenuItem value={9} primaryText="Last 12 Months" />
                                                                                <MenuItem value={10} primaryText="Last 24 Months" />
                                                                            </SelectField>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12">
                                                                <div className="row">
                                                                    <div className="col-sm-3 text-left" style={{ padding: "7px 13px" }}>
                                                                        <b>Show Me</b>
                                                                    </div>
                                                                    <div className="col-sm-9">

                                                                        <div className="row">
                                                                            <RadioButtonGroup name="shipSpeed" defaultSelected="all" style={styles.groupstyle} onChange={this.handleChange.bind(this)}>

                                                                                <RadioButton
                                                                                    value="all"
                                                                                    label="All"
                                                                                    style={styles.radioButton}
                                                                                    iconStyle={styles.radioIcon}
                                                                                    valueSelected="all"

                                                                                />
                                                                                <RadioButton
                                                                                    value="debit"
                                                                                    label="Debit"
                                                                                    style={styles.radioButton}
                                                                                    iconStyle={styles.radioIcon}
                                                                                    valueSelected="debit"

                                                                                />
                                                                                <RadioButton
                                                                                    value="credit"
                                                                                    label="Credit"
                                                                                    style={styles.radioButton}
                                                                                    iconStyle={styles.radioIcon}
                                                                                    valueSelected="credit"

                                                                                />
                                                                            </RadioButtonGroup>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="card-body">
                                                            <div className="row">
                                                                <div className="col-sm-4">
                                                                    <div className="row input-group" >
                                                                        <div className="col-sm-2 input-icon" style={{ top: "15px", right: "10px" }} >
                                                                            <i className="fa fa-calendar text-dark " aria-hidden="true" ></i>
                                                                        </div>
                                                                        <div className="col-sm-10 nopadding" >
                                                                            <DatePicker
                                                                                hintText="From Date"
                                                                                container="inline"
                                                                                name="activityFromDate"
                                                                                className="input-width"
                                                                                onChange={this.handleFromDate}
                                                                                style={styles.calendarStyle}
                                                                                formatDate={this.formatDate}
                                                                                maxDate={new Date()}
                                                                                textFieldStyle={styles.calendarTextStyle}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                <div className="col-sm-4">
                                                                    <div className="row input-group" >
                                                                        <div className="col-sm-2 activityinput" >
                                                                            <i className="fa fa-calendar text-dark " aria-hidden="true"></i>
                                                                        </div>
                                                                        <div className="col-sm-10 nopadding" >
                                                                            <DatePicker hintText="To Date"
                                                                                onChange={this.handleToDate}
                                                                                container="inline"
                                                                                name="activityToDate"
                                                                                maxDate={new Date()}
                                                                                onFocus={this.removetodate}
                                                                                formatDate={this.formatDate}
                                                                                className="input-width"
                                                                            //   errorText={todatestate ? null : "To-date should not less than from-date."}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                <div className="col-sm-3">
                                                                    <RaisedButton
                                                                        label="Show"
                                                                        className="pull-right"
                                                                        disabled={this.state.disabled}
                                                                        // style={styles.button}
                                                                        backgroundColor="#333"
                                                                        labelColor="#fff"
                                                                        onClick={this.handlecardactivity}
                                                                        style={{ marginTop: "10px" }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-12 transfer" style={{ marginTop: "30px" }}>

                                                        <div className="row box-shadow-style" style={{ marginBottom: "8%" }} >

                                                            <div className="pc-tab">
                                                                <input id="tab1" type="radio" name="pct" value="tab1" checked={this.state.selectedOption === 'tab1'} onChange={this.handleChange7.bind(this)} />
                                                                <input id="tab2" type="radio" name="pct" value="tab2" checked={this.state.selectedOption === 'tab2'} onChange={this.handleChange8.bind(this)} />
                                                                <div className="pull-right" style={{ marginRight: "20px" }}>
                                                                    <button className="btn btn-default" onClick={this.handleDownload.bind(this)} style={{ marginTop: "9px", padding: "3px 6px", fontSize: 14 }}><i className="fa fa-download" aria-hidden="true" style={{ marginRight: 10 }}></i>Download as PDF</button>
                                                                </div>
                                                                <nav>
                                                                    <ul>
                                                                        <li className="tab1">
                                                                            <label style={{ cursor: "pointer" }} htmlFor="tab1">Posted Transactions</label>
                                                                        </li>
                                                                        <li className="tab2">
                                                                            <label style={{ cursor: "pointer" }} htmlFor="tab2">Pending Transactions</label>
                                                                        </li>
                                                                    </ul>
                                                                </nav>
                                                                <section>
                                                                    <div className="tab1" style={{ minHeight: "100px" }}>
                                                                        {this.state.quickLoad && <Loader />}
                                                                        {this.props.cardactivity.body && this.state.loader ?
                                                                            <table className="table table-striped" id="carddivPrint">
                                                                                <thead>
                                                                                    <tr style={{ fontSize: "13px" }}>
                                                                                        <th style={{ width: "2%", padding: "10px 15px" }} >Trans Date</th>
                                                                                        <th style={{ width: "5%" }} >Trans Time</th>
                                                                                        <th style={{ width: "10%" }} >Trans Ref ID</th>
                                                                                        <th style={{ width: "30%", padding: "21px 6px" }}>Description</th>
                                                                                        <th style={{ width: "5%" }}>Card Number	</th>
                                                                                        <th style={{ width: "15%" }}>Debit <br />(-)</th>
                                                                                        <th style={{ width: "15%" }}>Credit <br />(+)</th>
                                                                                        <th style={{ width: "15%" }}>Running Balance</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>

                                                                                    {(this.state.value4 === "all") ?
                                                                                        this.props.cardactivity.body && this.props.cardactivity.body.transactions.length !== 0 && this.props.cardactivity.body.transactions.map((value, i) =>
                                                                                            <tr style={{ fontSize: "13px" }} key={i}>
                                                                                                <td>{cardactivity.body.transactions[i].transferDate}</td>
                                                                                                <td>{cardactivity.body.transactions[i].transferTime} { }</td>
                                                                                                <td>{cardactivity.body.transactions[i].transactionId} </td>
                                                                                                <td style={{ wordBreak: "break-all" }}>{cardactivity.body.transactions[i].typeOfTransfer}{cardactivity.body.transactions[i].comments}  </td>
                                                                                                <td>{cardactivity.body.transactions[i].lastFourDigitsCardNumber}</td>
                                                                                                {(cardactivity.body.transactions[i].debitAmount === "") ?
                                                                                                    <td>{cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                    :
                                                                                                    (cardactivity.body.transactions[i].debitAmount.startsWith("$")) ?
                                                                                                        <td> {cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                        :
                                                                                                        <td>${cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                }
                                                                                                {(cardactivity.body.transactions[i].creditAmount === "") ?
                                                                                                    <td>{cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                    :
                                                                                                    (cardactivity.body.transactions[i].creditAmount.startsWith("$")) ?
                                                                                                        <td> {cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                        :
                                                                                                        <td>${cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                }
                                                                                                <td>{cardactivity.body.transactions[i].balanceAmount.startsWith("$") ? cardactivity.body.transactions[i].balanceAmount : "$".concat(cardactivity.body.transactions[i].balanceAmount)}</td>
                                                                                            </tr>) :
                                                                                        (value4 === "debit" && cardactivity.body.hasDebitRecords === true) ?
                                                                                            cardactivity.body.transactions.length !== 0 && cardactivity.body.transactions.map((value, i) =>
                                                                                                (cardactivity.body.transactions[i].debitAmount !== "") ?
                                                                                                    <tr style={{ fontSize: "13px" }} key={i}>
                                                                                                        <td>{cardactivity.body.transactions[i].transferDate}</td>
                                                                                                        <td>{cardactivity.body.transactions[i].transferTime} { }</td>
                                                                                                        <td>{cardactivity.body.transactions[i].transactionId} </td>
                                                                                                        <td style={{ wordBreak: "break-all" }}>{cardactivity.body.transactions[i].typeOfTransfer}{cardactivity.body.transactions[i].comments}  </td>
                                                                                                        <td>{cardactivity.body.transactions[i].lastFourDigitsCardNumber}</td>
                                                                                                        {(cardactivity.body.transactions[i].debitAmount === "") ?
                                                                                                            <td>{cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                            :
                                                                                                            (cardactivity.body.transactions[i].debitAmount.startsWith("$")) ?
                                                                                                                <td> {cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                                :
                                                                                                                <td>${cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                        }
                                                                                                        {(cardactivity.body.transactions[i].creditAmount === "") ?
                                                                                                            <td>{cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                            :
                                                                                                            (cardactivity.body.transactions[i].creditAmount.startsWith("$")) ?
                                                                                                                <td> {cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                                :
                                                                                                                <td>${cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                        }
                                                                                                        <td>{cardactivity.body.transactions[i].balanceAmount.startsWith("$") ? cardactivity.body.transactions[i].balanceAmounte : "$".concat(cardactivity.body.transactions[i].balanceAmount)}</td>
                                                                                                    </tr>
                                                                                                    :
                                                                                                    <tr>
                                                                                                    </tr>
                                                                                            )
                                                                                            :
                                                                                            (value4 === "debit" && cardactivity.body.hasDebitRecords === false) ?
                                                                                                <span style={{ fontSize: "20px", position: "absolute", left: "275px" }}>
                                                                                                    No Records Found
                                                                 </span>

                                                                                                :
                                                                                                (value4 === "credit" && cardactivity.body.hasCreditRecords === true) ?
                                                                                                    cardactivity.body.transactions.length !== 0 && cardactivity.body.transactions.map((value, i) =>
                                                                                                        (cardactivity.body.transactions[i].creditAmount !== "") ?
                                                                                                            <tr style={{ fontSize: "13px" }} key={i}>
                                                                                                                <td>{cardactivity.body.transactions[i].transferDate}</td>
                                                                                                                <td>{cardactivity.body.transactions[i].transferTime} { }</td>
                                                                                                                <td>{cardactivity.body.transactions[i].transactionId} </td>
                                                                                                                <td style={{ wordBreak: "break-all" }}>{cardactivity.body.transactions[i].typeOfTransfer}{cardactivity.body.transactions[i].comments}  </td>
                                                                                                                <td>{cardactivity.body.transactions[i].lastFourDigitsCardNumber}</td>
                                                                                                                {(cardactivity.body.transactions[i].debitAmount === "") ?
                                                                                                                    <td>{cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                                    :
                                                                                                                    (cardactivity.body.transactions[i].debitAmount.startsWith("$")) ?
                                                                                                                        <td> {cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                                        :
                                                                                                                        <td>${cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                                }
                                                                                                                {(cardactivity.body.transactions[i].creditAmount === "") ?
                                                                                                                    <td>{cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                                    :
                                                                                                                    (cardactivity.body.transactions[i].creditAmount.startsWith("$")) ?
                                                                                                                        <td> {cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                                        :
                                                                                                                        <td>${cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                                }
                                                                                                                <td>{cardactivity.body.transactions[i].balanceAmount.startsWith("$") ? cardactivity.body.transactions[i].balanceAmounte : "$".concat(cardactivity.body.transactions[i].balanceAmount)}</td>
                                                                                                            </tr>
                                                                                                            :
                                                                                                            <tr>
                                                                                                            </tr>
                                                                                                    ) :
                                                                                                    (value4 === "credit" && cardactivity.body.hasCreditRecords === false) ?
                                                                                                        <span style={{ fontSize: "20px", position: "absolute", left: "275px" }}>
                                                                                                            No Records Found
                                                                </span> :
                                                                                                        <div>
                                                                                                        </div>


                                                                                    }


                                                                                    {cardactivity.status === 200 && cardactivity.body.transactions.length === 0 &&
                                                                                        <div className="row">
                                                                                            <span style={{ fontSize: "20px", position: "absolute", left: "275px" }}>
                                                                                                No Records Found
                                                                 </span>

                                                                                        </div>}

                                                                                </tbody>
                                                                            </table>
                                                                            : <Loader />
                                                                        }
                                                                    </div>
                                                                    <div className="tab2" style={{ minHeight: "100px" }}>

                                                                        {this.props.cardactivity.body && this.state.loader ?
                                                                            //   this.props.cardactivty.status === 200 &&  this.props.cardactivty.length !== 0 ?
                                                                            <table className="table table-striped" id="carddivPrint">

                                                                                <thead>
                                                                                    <tr style={{ fontSize: "13px" }}>
                                                                                        <th style={{ width: "2%", padding: "10px 15px" }} >Trans Date</th>
                                                                                        <th style={{ width: "5%" }} >Trans Time</th>
                                                                                        <th style={{ width: "10%" }} >Trans Ref ID</th>
                                                                                        <th style={{ width: "30%", padding: "21px 6px" }}>Description</th>
                                                                                        <th style={{ width: "5%" }}>Card Number	</th>
                                                                                        <th style={{ width: "15%" }}>Debit <br />(-)</th>
                                                                                        <th style={{ width: "15%" }}>Credit <br />(+)</th>
                                                                                        <th style={{ width: "15%" }}>Running Balance</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {(this.state.value4 === "all") ?
                                                                                        this.props.cardactivity.body && this.props.cardactivity.body.transactions.length !== 0 && this.props.cardactivity.body.transactions.map((value, i) =>
                                                                                            <tr style={{ fontSize: "13px" }} key={i}>
                                                                                                <td>{cardactivity.body.transactions[i].transferDate}</td>
                                                                                                <td>{cardactivity.body.transactions[i].transferTime} { }</td>
                                                                                                <td>{cardactivity.body.transactions[i].transactionId} </td>
                                                                                                <td style={{ wordBreak: "break-all" }}>{cardactivity.body.transactions[i].typeOfTransfer}{cardactivity.body.transactions[i].comments}  </td>
                                                                                                <td>{cardactivity.body.transactions[i].lastFourDigitsCardNumber}</td>
                                                                                                {(cardactivity.body.transactions[i].debitAmount !== "") ?
                                                                                                    <td>${cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                    :
                                                                                                    <td> {cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                }
                                                                                                {(cardactivity.body.transactions[i].creditAmount !== "") ?
                                                                                                    <td>${cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                    :
                                                                                                    <td> {cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                }

                                                                                                <td>$ {cardactivity.body.transactions[i].balanceAmount}</td>
                                                                                            </tr>) :
                                                                                        (value4 === "debit" && cardactivity.body.hasDebitRecords === true) ?
                                                                                            cardactivity.body.transactions.length !== 0 && cardactivity.body.transactions.map((value, i) =>
                                                                                                (cardactivity.body.transactions[i].debitAmount !== "") ?
                                                                                                    <tr style={{ fontSize: "13px" }} key={i}>
                                                                                                        <td>{cardactivity.body.transactions[i].transferDate}</td>
                                                                                                        <td>{cardactivity.body.transactions[i].transferTime} { }</td>
                                                                                                        <td>{cardactivity.body.transactions[i].transactionId} </td>
                                                                                                        <td style={{ wordBreak: "break-all" }}>{cardactivity.body.transactions[i].typeOfTransfer}{cardactivity.body.transactions[i].comments}  </td>
                                                                                                        <td>{cardactivity.body.transactions[i].lastFourDigitsCardNumber}</td>
                                                                                                        {(cardactivity.body.transactions[i].debitAmount === "") ?
                                                                                                            <td>{cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                            :
                                                                                                            (cardactivity.body.transactions[i].debitAmount.startsWith("$")) ?
                                                                                                                <td> {cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                                :
                                                                                                                <td>${cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                        }
                                                                                                        {(cardactivity.body.transactions[i].creditAmount === "") ?
                                                                                                            <td>{cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                            :
                                                                                                            (cardactivity.body.transactions[i].creditAmount.startsWith("$")) ?
                                                                                                                <td> {cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                                :
                                                                                                                <td>${cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                        }
                                                                                                        <td>{cardactivity.body.transactions[i].balanceAmount.startsWith("$") ? cardactivity.body.transactions[i].balanceAmounte : "$".concat(cardactivity.body.transactions[i].balanceAmount)}</td>
                                                                                                    </tr>
                                                                                                    :
                                                                                                    <tr>
                                                                                                    </tr>
                                                                                            )
                                                                                            :
                                                                                            (value4 === "debit" && cardactivity.body.hasDebitRecords === false) ?
                                                                                                <span style={{ fontSize: "20px", position: "absolute", left: "275px" }}>
                                                                                                    No Records Found
                                                                 </span>

                                                                                                :
                                                                                                (value4 === "credit" && cardactivity.body.hasCreditRecords === true) ?
                                                                                                    cardactivity.body.transactions.length !== 0 && cardactivity.body.transactions.map((value, i) =>
                                                                                                        (cardactivity.body.transactions[i].creditAmount !== "") ?
                                                                                                            <tr style={{ fontSize: "13px" }} key={i}>
                                                                                                                <td>{cardactivity.body.transactions[i].transferDate}</td>
                                                                                                                <td>{cardactivity.body.transactions[i].transferTime} { }</td>
                                                                                                                <td>{cardactivity.body.transactions[i].transactionId} </td>
                                                                                                                <td style={{ wordBreak: "break-all" }}>{cardactivity.body.transactions[i].typeOfTransfer}{cardactivity.body.transactions[i].comments}  </td>
                                                                                                                <td>{cardactivity.body.transactions[i].lastFourDigitsCardNumber}</td>
                                                                                                                {(cardactivity.body.transactions[i].debitAmount === "") ?
                                                                                                                    <td>{cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                                    :
                                                                                                                    (cardactivity.body.transactions[i].debitAmount.startsWith("$")) ?
                                                                                                                        <td> {cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                                        :
                                                                                                                        <td>${cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                                }
                                                                                                                {(cardactivity.body.transactions[i].creditAmount === "") ?
                                                                                                                    <td>{cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                                    :
                                                                                                                    (cardactivity.body.transactions[i].creditAmount.startsWith("$")) ?
                                                                                                                        <td> {cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                                        :
                                                                                                                        <td>${cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                                }
                                                                                                                <td>{cardactivity.body.transactions[i].balanceAmount.startsWith("$") ? cardactivity.body.transactions[i].balanceAmounte : "$".concat(cardactivity.body.transactions[i].balanceAmount)}</td>
                                                                                                            </tr>
                                                                                                            :
                                                                                                            <tr>
                                                                                                            </tr>
                                                                                                    ) :
                                                                                                    (value4 === "credit" && cardactivity.body.hasCreditRecords === false) ?
                                                                                                        <span style={{ fontSize: "20px", position: "absolute", left: "275px" }}>
                                                                                                            No Records Found
                                                                </span> :
                                                                                                        <div>
                                                                                                        </div>


                                                                                    }


                                                                                    {cardactivity.status === 200 && cardactivity.body.transactions.length === 0 &&
                                                                                        <div className="row">
                                                                                            <span style={{ fontSize: "20px", position: "absolute", left: "275px" }}>
                                                                                                No Records Found
                                                                 </span>

                                                                                        </div>}

                                                                                </tbody>
                                                                            </table>
                                                                            : <Loader />
                                                                        }
                                                                    </div>
                                                                </section>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            }
                                            {this.state.valueTab === 2 &&
                                                <div className="col-sm-12" style={{ padding: "0px", boxShadow: "0px 1px 3px 2px rgba(0,0,0,0.2)", }}>
                                                    <div className="col-md-12" style={{ padding: "10px 8px 0px 3px" }}>
                                                        <div className="summary-header">
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <p>Change PIN Details</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 top-header text-left">
                                                        <span>To help protect your security, the keyboard entry has been disabled. Please use the on-screen keypad to enter your card PIN. Click on the respective field to launch the on-screen keypad.</span>
                                                    </div>
                                                    <div className="col-md-12 col-sm-12" style={{ marginTop: '20px' }}>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-12">
                                                                <div className="row">
                                                                    <div className="col-md-12 col-sm-12">
                                                                        <div className="row">
                                                                            <div className="offset-md-1  col-md-11 col-sm-12">
                                                                                <div className="row input-group" >
                                                                                    <div className="col-sm-2 passwordinput" >
                                                                                        <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                                                                    </div>
                                                                                    <div className="col-sm-10" >
                                                                                        <div className="group" id="newpin" >
                                                                                            <KeyboardedInput
                                                                                                type={"password"}
                                                                                                value={this.state.newPIN}
                                                                                                onChange={(value) => { this.handleValueChangenew(value); }}
                                                                                                enabled
                                                                                                name={"newPIN"}
                                                                                                opacity={1}
                                                                                                className="required"
                                                                                                defaultKeyboard={this.state.customMapping}
                                                                                                placeholder={'Enter New 4 Digit Pin'}
                                                                                                step={4}
                                                                                                isDraggable={false}
                                                                                                onBlur={this.removepin}
                                                                                                errorText={correctpin ? null : "Should contain 4 digits."}

                                                                                            />
                                                                                            <div id="errornew">Should contain maximum 4 digits.</div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                    <div className="col-md-12 col-sm-12">
                                                                        <div className="row">
                                                                            <div className="offset-md-1 col-md-11 col-sm-12" style={{ zIndex: "0" }}>
                                                                                <div className="row input-group" >
                                                                                    <div className="col-sm-2 passwordinput" >
                                                                                        <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                                                                    </div>
                                                                                    <div className="col-sm-10" >
                                                                                        <div className="group" id="confpin" >
                                                                                            <KeyboardedInput

                                                                                                type={"password"}
                                                                                                value={this.state.confirmPIN}
                                                                                                onChange={(value) => { this.handleValueChange(value); }}
                                                                                                enabled
                                                                                                name={"confirmPIN"}
                                                                                                opacity={1}
                                                                                                className="required"
                                                                                                defaultKeyboard={this.state.customMapping}
                                                                                                placeholder={'Confirm Your Pin'}
                                                                                                step={4}
                                                                                                isDraggable={false}
                                                                                            />
                                                                                            {/* <InputMask type="password"
                                                                            name="confirmPIN"
                                                                            placeholder="Confirm Your Pin"
                                                                            onChange={this.onChange}
                                                                            maskChar="" /> */}
                                                                                            <div id="errorconfirm">Should contain maximum 4 digits.</div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-8 offset-4" style={{ marginTop: "7px", marginBottom: "10px", padding: "0px 0px 15px 35px" }}>
                                                        <RaisedButton
                                                            label="Submit"
                                                            backgroundColor="#333"
                                                            labelColor="#fff"
                                                            disabled={this.state.disabled}
                                                            onClick={this.handlePINSubmit.bind(this)}
                                                        />
                                                    </div>

                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <Loader />
                }
                <div className="col-sm-12 modal-for-login flowmodal" id="myModal" style={{ display: "none" }}>
                    <div className="modal-content col-sm-4" style={{ background: "rgb(214, 70, 84)" }}>
                        <div className="modal-header" style={{ borderBottom: "none", height: "45px" }}>
                            <div className="col-sm-12" style={{ marginTop: "-7px" }}>
                                <div className="row">
                                    <div className="col-sm-6" style={{ fontSize: "19px", fontWeight: "600", color: "rgb(255, 255, 255)" }}>
                                        <span>Update Card Status</span>
                                    </div>
                                    <div className="offset-4 col-sm-2" style={{ float: "right" }}>
                                        <button type="button" className="close" data-dismiss="modal" style={{ marginTop: "-19px" }} onClick={this.handleClose.bind(this)} aria-label="Close">
                                            <span aria-hidden="true" style={{ color: "#fff", fontSize: "22px" }}>&times;</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-body text-center" style={{ backgroundColor: "#fff" }}>
                            <div className="col-sm-12" >
                                <i className="fa fa-question fa-4x mb-3 animated rotateIn" style={{ color: "rgb(214, 70, 84)" }}></i>
                            </div>
                            <div className="col-sm-12" style={{ fontSize: "20px" }}>
                                <span>Are you sure, you want to update card status?</span>
                            </div>
                            <div className="col-sm-12" >
                                <div className="row">
                                    <div className="col-sm-3 offset-3" style={{ padding: "0px", textAlign: "right" }}>
                                        <button type="button" className="btn btn-outline-danger waves-effect" data-dismiss="modal" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)", padding: "3px 15px" }}
                                            onClick={this.handleClose.bind(this)}
                                            aria-label="Close">
                                            Cancel
                                       </button>
                                    </div>
                                    <div className="col-sm-3" style={{ textAlign: "left" }}>
                                        <button type="button" className="btn btn-outline-danger waves-effect" data-dismiss="modal" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)", padding: "3px 15px" }}
                                            onClick={this.handleUpdate.bind(this)}
                                            aria-label="Close">
                                            OK
                                       </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="col-sm-12 modal-for-login flowmodal" id="myModal1" style={{ display: "none" }}>
                    <div className="modal-content col-sm-4" style={{ background: "rgb(214, 70, 84)" }}>
                        <div className="modal-header" style={{ borderBottom: "none", height: "45px" }}>
                            <div className="col-sm-12" style={{ marginTop: "-7px" }}>
                                <div className="row">
                                    <div className="col-sm-6" style={{ fontSize: "19px", fontWeight: "600", color: "rgb(255, 255, 255)" }}>
                                        <span>Update Email Address</span>
                                    </div>
                                    <div className="offset-4 col-sm-2" style={{ float: "right" }}>
                                        <button type="button" className="close" data-dismiss="modal" style={{ marginTop: "-19px" }} onClick={this.handleClose1.bind(this)} aria-label="Close">
                                            <span aria-hidden="true" style={{ color: "#fff", fontSize: "22px" }}>&times;</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-body text-center" style={{ backgroundColor: "#fff" }}>
                            <div className="col-sm-12" >
                                <i className="fa fa-question fa-4x mb-3 animated rotateIn" style={{ color: "rgb(214, 70, 84)" }}></i>
                            </div>
                            <div className="col-sm-12" style={{ fontSize: "20px" }}>
                                <span>Are you sure, you want to update Email Address?</span>
                            </div>
                            <div className="col-sm-12" >
                                <div className="row">
                                    <div className="col-sm-3 offset-3" style={{ padding: "0px", textAlign: "right" }}>
                                        <button type="button" className="btn btn-outline-danger waves-effect" data-dismiss="modal" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)", padding: "3px 15px" }}
                                            onClick={this.handleClose1.bind(this)}
                                            aria-label="Close">
                                            Cancel
                                       </button>
                                    </div>
                                    <div className="col-sm-3" style={{ textAlign: "left" }}>
                                        <button type="button" className="btn btn-outline-danger waves-effect" data-dismiss="modal" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)", padding: "3px 15px" }}
                                            onClick={this.handleUpdateEmail.bind(this)}
                                            aria-label="Close">
                                            OK
                                       </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className="col-sm-12 modal-for-login flowmodal" id="myModal2" style={{ display: "none" }}>
                    <div className="modal-content col-sm-4" style={{ background: "rgb(214, 70, 84)" }}>
                        <div className="modal-header" style={{ borderBottom: "none", height: "45px" }}>
                            <div className="col-sm-12" style={{ marginTop: "-7px" }}>
                                <div className="row">
                                    <div className="col-sm-6" style={{ fontSize: "19px", fontWeight: "600", color: "rgb(255, 255, 255)" }}>
                                        <span>Reset PIN</span>
                                    </div>
                                    <div className="offset-4 col-sm-2" style={{ float: "right" }}>
                                        <button type="button" className="close" data-dismiss="modal" style={{ marginTop: "-19px" }} onClick={this.handleClose2.bind(this)} aria-label="Close">
                                            <span aria-hidden="true" style={{ color: "#fff", fontSize: "22px" }}>&times;</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-body text-center" style={{ backgroundColor: "#fff" }}>
                            <div className="col-sm-12" >
                                <i className="fa fa-question fa-4x mb-3 animated rotateIn" style={{ color: "rgb(214, 70, 84)" }}></i>
                            </div>
                            <div className="col-sm-12" style={{ fontSize: "20px" }}>
                                <span>Are you sure, you want to change card pin?</span>
                            </div>
                            <div className="col-sm-12" >
                                <div className="row">
                                    <div className="col-sm-3 offset-3" style={{ padding: "0px", textAlign: "right" }}>
                                        <button type="button" className="btn btn-outline-danger waves-effect" data-dismiss="modal" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)", padding: "3px 15px" }}
                                            onClick={this.handleClose.bind(this)}
                                            aria-label="Close">
                                            Cancel
                                       </button>
                                    </div>
                                    <div className="col-sm-3" style={{ textAlign: "left" }}>
                                        <button type="button" className="btn btn-outline-danger waves-effect" data-dismiss="modal" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)", padding: "3px 15px" }}
                                            onClick={this.handleUpdatePIN.bind(this)}
                                            aria-label="Close">
                                            OK
                                       </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CardDetails);


// WEBPACK FOOTER //
// ./src/components/adminuser/carddetails.jsx